import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Navigate } from 'react-router-dom';
import Button from '../../../components/Button';
import Dropdown from '../../../components/Dropdown';
import { usePermission } from '../../../hooks/usePermission';
import TenantService from '../../../services/tenant.service';
import { Modules, AuthRoutes, RouteParamsTypes, NonAuthRoutes } from '../../../enums';
import TenantUserListPanel from './TenantUserListPanel';

interface TenantOption {
  id: number;
  tenant_name: string;
}

const TenantUsersList: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canManageUsers = usePermission('user:invite');

  const [tenants, setTenants] = useState<TenantOption[]>([]);
  const [tenantFilter, setTenantFilter] = useState('');

  useEffect(() => {
    TenantService.list({ includeDeleted: false, limit: 100 }).then((response: any) => {
      setTenants(response?.data?.items ?? []);
    });
  }, []);

  if (!canManageUsers) {
    return <Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.forbidden }} />;
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">{t('tenantUsers.list.pageTexts.title')}</h4>
        <Button
          className="btn btn-primary"
          text={t('tenantUsers.list.pageTexts.addNew')}
          onClick={() => navigate(`${Modules.iam}${AuthRoutes.tenantUsers}${RouteParamsTypes.add}`)}
        />
      </div>

      <div className="mb-4" style={{ maxWidth: '300px' }}>
        <Dropdown
          name="tenantFilter"
          value={tenantFilter}
          placeholder={t('tenantUsers.list.pageTexts.filters.allTenants')}
          options={tenants.map((tItem) => ({ id: String(tItem.id), name: tItem.tenant_name }))}
          noSearch
          onChange={(e) => setTenantFilter(e.target.value)}
        />
      </div>

      <TenantUserListPanel tenantId={tenantFilter || undefined} />
    </>
  );
};

export default TenantUsersList;
